<script>
import {axios} from '../mixins';

export default {
  name: 'StateSelector',

  mixins: [axios],

  props: {
    options: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    stateValue: {
      required: false,
      default: null,
    },
    countyValue: {
      required: false,
      default: null,
    },
    countyName: {
      required: false,
      default: null,
    },
  },

  watch: {
    stateValue: {
      immediate: true,
      handler(newValue) {
        this.state = newValue || '';

        if (this.state) {
          this.getCounties();
        } else {
          this.counties = ['Please select a state...'];
          this.county = '';
        }
      }
    },

    countyValue: {
      immediate: true,
      handler(newValue) {
        this.county = newValue || '';
      }
    },
  },

  data() {
    return {
      states: [],
      state: '',
      counties: [
        'Please select a state...'
      ],
      county: '',
      editableClassesSelect: 'bg-secondary italic rounded border border-grey-lighter w-full py-2 px-3 leading-tight focus:outline-none focus:ring',
    };
  },

  created() {
    if (Object.keys(this.options).length === 0) {
      this.getOptions();
    } else {
      this.states = Object.values(this.options);
    }
  },

  methods: {
    getOptions() {
      this.get('/states').then((response) => {
        this.states = Object.values(response.data.states);

        if (this.stateValue) {
          this.state = this.stateValue;
          this.getCounties();
        }
      }).catch((response) => {
        console.log(response);
      });
    },

    updateState() {
      if (this.state) {
        this.$emit('updateState', this.state);
        this.$emit('updateCounty', '');
        this.county = '';
        this.getCounties();
      } else {
        this.counties = ['Please select a state...'];
        this.county = '';
        this.$emit('updateState', '');
        this.$emit('updateCounty', '');
      }
    },

    updateCounty() {
      this.$emit('updateCounty', this.county || '');
    },

    getCounties() {
      this.get('/counties', {
        params: {
          state: this.state
        }
      }).then((response) => {
        this.counties = response.data.counties || [];

        if (this.countyValue) {
          this.county = this.countyValue;
          return;
        }

        if (this.countyName) {
          const normalizedTarget = this.normalizeCountyName(this.countyName);

          const match = this.counties.find((county) => {
            return this.normalizeCountyName(county.name) === normalizedTarget;
          });

          if (match) {
            this.county = match.fips;
            this.$emit('updateCounty', match.fips);
            return;
          }
        }

        this.county = '';
      });
    },

    normalizeCountyName(value) {
      if (!value) {
        return '';
      }

      return String(value)
          .replace(/\bcounty\b/i, '')
          .replace(/\bparish\b/i, '')
          .replace(/\s+/g, ' ')
          .trim()
          .toUpperCase();
    },
  },
};
</script>

<template>
  <select
      :name="$attrs['name']"
      :disabled="$attrs['disabled']"
      :class="editableClassesSelect"
      v-model="state"
      ref="stateSelect"
      @change="updateState"
  >
    <option value="">Select State</option>
    <option v-for="state in states" :key="state.abbreviation ?? state" :value="state.abbreviation ?? state">
      {{ state.abbreviation ?? state }}
    </option>
  </select>

  <label for="county" class="font-semibold mb-1 block">County</label>
  <select
      :disabled="$attrs['disabled']"
      :class="editableClassesSelect"
      name="county"
      v-model="county"
      ref="countySelect"
      @change="updateCounty"
  >
    <option value="">Select County</option>
    <option v-for="county in counties" :key="county.fips ?? county" :value="county.fips ?? county">
      {{ county.name ?? county }}
    </option>
  </select>
</template>